import React, { useState } from 'react';

import { filter } from 'lodash';

import { column } from '@/config/ReportsTable.config';
import Icons from '@/icons';
import { iconConstants } from '@/constants';
import { generalHelpers, reportHelpers } from '@/helpers';
import { AppSkeleton, Table, SongLogTable } from '@/component';
import { Button, Input } from '@/kaya';
import { songsStore } from '@/store';
import { userActions } from '@/actions';
import { songTypes } from '@/types';

import styles from './Reports.module.scss';

const Reports = () => {
  const { songs } = songsStore();

  const [visible, setVisible] = useState(false);
  const [search, setSearch] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [songLog, setSongLog] = useState([]);

  const acceptedSongData = filter(songs, (item: any) => item.submission_status === 'ACCEPTED');

  const handleDownloadExel = () => {
    generalHelpers.downloadExcel(acceptedSongData, 'Reports');
  };
  const handleCloseSongTable = () => {
    setVisible(false);
  };

  const handleRowClick = async (item: songTypes.Song) => {
    setVisible(true);
    setIsLoading(true);
    const data = await userActions.fetchSongLogAction(item.id);
    setIsLoading(false);
    setSongLog(data.data);
  };

  return (
    <AppSkeleton>
      <div className={styles.Reports}>
        <Input
          placeholder="Find your music"
          width="100%"
          onChange={setSearch}
          prefixIcon={<Icons type={iconConstants.ICONS.SEARCH_ICON} />}
        />
        <div className={styles.secondLayer}>
          <p className={styles.header}>Reports</p>
          <Button type="Primary" width="200px" onClick={handleDownloadExel}>
            Download Reports
          </Button>
        </div>
      </div>
      <div style={{ height: 'calc(100vh - 224px)' }}>
        <Table
          columns={column}
          rows={reportHelpers.searchResult(songs, search)}
          disableActions
          handleRowClick={handleRowClick}
        />
      </div>
      <SongLogTable
        visible={visible}
        setVisible={handleCloseSongTable}
        data={songLog}
        isLoading={isLoading}
      />
    </AppSkeleton>
  );
};

export default Reports;
